import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  style: {"margin":"5px 0 20px"}
}
const _hoisted_7 = {
  key: 0,
  style: {"margin-top":"8px","color":"var(--ai-accent-deep)","font-weight":"600","font-size":"14px"}
}
const _hoisted_8 = {
  key: 1,
  style: {"margin-top":"8px","color":"var(--ai-accent-deep)","font-weight":"600","font-size":"14px"}
}
const _hoisted_9 = {
  key: 2,
  style: {"margin-top":"8px","color":"var(--ai-accent-deep)","font-weight":"600","font-size":"14px"}
}
const _hoisted_10 = {
  key: 3,
  style: {"margin-top":"8px","color":"var(--ai-accent-deep)","font-weight":"600","font-size":"14px"}
}
const _hoisted_11 = {
  key: 1,
  style: {"margin-bottom":"20px"}
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { style: {"font-size":"12.5px","line-height":"1.45","color":"var(--font-mid-gray)"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 3,
  style: {"margin-bottom":"25px"}
}
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { style: {"margin-bottom":"20px","max-height":"80px","overflow":"auto"} }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { style: {"margin-bottom":"20px","max-height":"80px","overflow":"auto"} }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { key: 5 }
const _hoisted_23 = {
  key: 6,
  style: {"margin-bottom":"20px","max-height":"80px","overflow":"auto"}
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 7,
  style: {"margin-bottom":"20px"}
}
const _hoisted_26 = {
  key: 8,
  style: {"margin-bottom":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_process_owner_picker = _resolveComponent("process-owner-picker")!
  const _component_ai_process_modal = _resolveComponent("ai-process-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Name", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSlug()))
      }, null, 544), [
        [_vModelText, _ctx.formData.Name]
      ]),
      _createElementVNode("div", null, [
        (_ctx.formData.isNew)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Slug"))
          : _createCommentVNode("", true),
        (_ctx.formData.isNew)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.Slug) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editSlug()))
            }, null, 544)), [
              [_vModelText, _ctx.formData.Slug]
            ])
          : _createCommentVNode("", true),
        (!_ctx.$props.node)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Type", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.Type) = $event))
              }, [...(_cache[17] || (_cache[17] = [
                _createStaticVNode("<option value=\"PROCESS\">Process</option><option value=\"TIMELINE\">Value Engine</option><option value=\"SHEET\">Sheet</option><option value=\"CHECKLIST\">Checklist</option><option value=\"LINK\">Link</option><option value=\"VIDEO\">Video</option><option value=\"NODE\">Folder</option>", 7)
              ]))], 512), [
                [_vModelSelect, _ctx.formData.Type]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      ((_ctx.formData.Type == 'PROCESS' || _ctx.formData.Type == 'CHECKLIST' || _ctx.formData.Type == 'SHEET' || _ctx.formData.Type == 'TIMELINE') && _ctx.formData.isNew && !_ctx.cloneNode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "ai-btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAIModal = true))
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
              ], -1),
              _createTextVNode(" Generate with AI ", -1)
            ]))]),
            (_ctx.formData.Type == 'PROCESS' && _ctx.aiProcessJSON)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " ✓ AI draft attached — the process content will be filled in automatically "))
              : _createCommentVNode("", true),
            (_ctx.formData.Type == 'CHECKLIST' && _ctx.aiChecklistJSON)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " ✓ AI draft attached — the checklist items will be filled in automatically "))
              : _createCommentVNode("", true),
            (_ctx.formData.Type == 'SHEET' && _ctx.aiSheetJSON)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " ✓ AI draft attached — the sheet grid will be filled in automatically "))
              : _createCommentVNode("", true),
            (_ctx.formData.Type == 'TIMELINE' && _ctx.aiTimelineJSON)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " ✓ AI draft attached — the value engine steps will be filled in automatically "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.formData.Type == 'SHEET' && _ctx.formData.isNew && !_ctx.cloneNode && !_ctx.aiSheetJSON && (_ctx.sheetTemplates.length || _ctx.canManageSheetTemplates))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Start from", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sheetTemplateID) = $event)),
              style: {"margin-bottom":"6px"}
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "Default", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherSheetTemplates, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.ID,
                  value: t.ID
                }, _toDisplayString(t.Name), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.sheetTemplateID]
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.chosenSheetTemplate && _ctx.chosenSheetTemplate.Description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.chosenSheetTemplate.Description), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, "Sections: " + _toDisplayString(_ctx.chosenSheetSections.map((s) => s.label).join(', ')), 1),
              (_ctx.canManageSheetTemplates)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    style: {"text-decoration":"underline","cursor":"pointer"},
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.manageSheetTemplates()), ["prevent"]))
                  }, "Manage templates"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.formData.Type == 'LINK' || _ctx.formData.Type == 'VIDEO')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Link", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.Link) = $event)),
              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkLink()))
            }, null, 544), [
              [_vModelText, _ctx.formData.Link]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.formData.Type == 'LINK' || _ctx.formData.Type == 'VIDEO')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_drop_file, { onFileChange: _ctx.onFileChange }, null, 8, ["onFileChange"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.formData.Type == 'PROCESS' || _ctx.formData.Type == 'SHEET' || _ctx.formData.Type == 'TIMELINE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[23] || (_cache[23] = _createElementVNode("h3", null, "Process Owner", -1)),
            _createVNode(_component_process_owner_picker, {
              modelValue: _ctx.ownerIDs,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ownerIDs) = $event)),
              style: {"margin-bottom":"20px"}
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _cache[29] || (_cache[29] = _createElementVNode("h3", null, "Locations", -1)),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.LocationsNew, (location, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "checkbox-input"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": ($event: any) => ((location.isChecked) = $event)
            }, null, 8, _hoisted_19), [
              [_vModelCheckbox, location.isChecked]
            ]),
            _createElementVNode("div", null, _toDisplayString(location.name), 1)
          ]))
        }), 128))
      ]),
      _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Departments", -1)),
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.DepartmentsNew, (department, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "checkbox-input"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": ($event: any) => ((department.isChecked) = $event)
            }, null, 8, _hoisted_21), [
              [_vModelCheckbox, department.isChecked]
            ]),
            _createElementVNode("div", null, _toDisplayString(department.name), 1)
          ]))
        }), 128))
      ]),
      (_ctx.formData.Type != 'NODE')
        ? (_openBlock(), _createElementBlock("h3", _hoisted_22, "Types"))
        : _createCommentVNode("", true),
      (_ctx.formData.Type != 'NODE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.TypesNew, (type, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "checkbox-input"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((type.isChecked) = $event)
                }, null, 8, _hoisted_24), [
                  [_vModelCheckbox, type.isChecked]
                ]),
                _createElementVNode("div", null, _toDisplayString(type.name), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.status) = $event))
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("option", { value: "Draft" }, "Draft", -1),
              _createElementVNode("option", { value: "Inactive" }, "Inactive", -1),
              _createElementVNode("option", { value: "Needs Approval" }, "Needs Approval", -1),
              _createElementVNode("option", { value: "" }, "Published/Approved", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.status]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSignChoice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("label", {
              class: _normalizeClass(['ep-opt', { on: !_ctx.minorChange }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.minorChange) = $event)),
                type: "radio",
                value: false
              }, null, 512), [
                [_vModelRadio, _ctx.minorChange]
              ]),
              _createElementVNode("span", null, [
                _cache[26] || (_cache[26] = _createElementVNode("b", null, "Yes, people need to sign again", -1)),
                _createElementVNode("small", null, "Saves as v" + _toDisplayString(_ctx.formData.Version + 1) + ". Everyone assigned is asked to sign it.", 1)
              ])
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(['ep-opt', { on: _ctx.minorChange }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.minorChange) = $event)),
                type: "radio",
                value: true
              }, null, 512), [
                [_vModelRadio, _ctx.minorChange]
              ]),
              _createElementVNode("span", null, [
                _cache[27] || (_cache[27] = _createElementVNode("b", null, "No, it's a small fix", -1)),
                _createElementVNode("small", null, "Stays v" + _toDisplayString(_ctx.formData.Version) + ", and anyone who signed it stays signed.", 1)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: "Submit",
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submit()))
      }, null, 2)
    ]),
    (_ctx.showAIModal)
      ? (_openBlock(), _createBlock(_component_ai_process_modal, {
          key: 0,
          mode: "generate",
          "node-type": _ctx.formData.Type == 'CHECKLIST' ? 'checklist' : _ctx.formData.Type == 'SHEET' ? 'sheet' : _ctx.formData.Type == 'TIMELINE' ? 'timeline' : 'process',
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showAIModal = false)),
          onAccept: _ctx.onAIDraft
        }, null, 8, ["node-type", "onAccept"]))
      : _createCommentVNode("", true)
  ]))
}